// extracted by mini-css-extract-plugin
export var choice = "GW6TZ";
export var choiceItem = "QdadC";
export var choiceList = "Y1DNc";
export var container = "qWDpO";
export var divider = "_3tnx+";
export var dividerLine = "KqTFp";
export var dividerText = "rs0J0";